module.exports = __webpack_public_path__ + "img/8d0a884.jpg";